import React from "react";
import CarePlanCard from "./CarePlanCard";
import NoDataMessageComponent from "../../../components/generic/nodatamessage/NoDataMessageComponent";
import { Spin } from "antd";

const CarePlanCardWrapper = ({ tableData, showPatientInfo, tableLoading, spinnerClass }) => {
  return (
    <>
    {
      tableLoading ? (
        <Spin
          className={spinnerClass ? "spinnerCenter" : ""}
          size={spinnerClass ? undefined : "large"}
          style={
            !spinnerClass ? { display: "flex", justifyContent: "center" } : {}
          }
        />
      ) :
      !tableData.length ? (
        <NoDataMessageComponent text="No data found!" />
      ) : (
        <div className="care-plan-card">
          {tableData?.map((careplan) => {
            return (
              <div key={careplan?.id} className="careplan-main-card-section card">
                <CarePlanCard careplan={careplan} showPatientInfo={showPatientInfo} />
              </div>
            );
          })}
        </div>
      )
    }
    </>
  );
};

export default CarePlanCardWrapper;
